<template>
    <div class="row row-grid justify-content-between align-items-center mt-lg">
        <div class="col-lg-5">
            <h3 class="h4 text-success font-weight-bold mb-4">Lịch Sử Phát Triển</h3>
            <p>CÔNG TY  CỔ PHẦN DỊCH VỤ TRỰC TUYẾN ỐC TA (OCTA JSC) được thành lập theo Đăng ký KD số: 0108313142 do Sở KH & ĐT thành phố Hà Nội cấp ngày 06 tháng 06 năm 2018.
              Mặc dù được thành lập chưa lâu, nhưng với các tiềm lực sẵn có, OCTA đã nỗ lực phát triển không ngừng và từng bước khẳng định được vị trí dẫn đầu trên thị trường phân phối các sản phẩm, dịch vụ viễn thông của các nhà mạng tại Việt Nam. 
              Với chiến lược đầu tư nghiên cứu công nghệ cao và liên tục phát triển giải pháp mới, mở rộng lĩnh vực hoạt động dựa trên thế mạnh sẵn có, Công ty đã định hướng hệ thống của OCTA là mạng thanh toán tiên phong tại thị trường Việt Nam,
               xây dựng mô hình Cổng thanh toán dịch vụ trực tuyến, thông qua Hệ thống thanh toán kết nối với các Ngân hàng và các nhà cung cấp dịch được kết nối với nhau tạo ra mạng lưới thanh toán rộng khắp cả nước.
               </p>
         </div>
         <div class="col-lg-5">
            <img src="img/brand/dichvusanpham.jpg" class="image imagedt">
            <img src="img/brand/2.jpg" class="image imagedt">
         </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      pagination: {
        default: 1,
        danger: 3
      }
    };
  }
};
</script>
<style>
.image{
    width: 500px;
    height: 250px;
  }
@media (max-width: 768px){
  .imagedt{
    width: 100%;
    height: 190px;
  }
  
}
</style>
